/*
 * cz-quickview-swatch-sync.js
 * Fix voor quick view ("View" / "Choose options") op productkaarten i.c.m. Rubik Combined Listings.
 *
 * Probleem: na een klik op een Rubik-kleurswatch op een productkaart opent de quick view nog
 * het oorspronkelijke product (data-product-url wordt server-side gezet en nooit bijgewerkt).
 *
 * Oplossing: vlak voordat de quick view opent, de URL van de modal gelijkzetten aan het product
 * dat op dat moment op de kaart staat (Rubik werkt de titel-link van de kaart wel bij).
 * Werkt op alle kaarten: collecties, home, zoeken, recently viewed, header search, cart drawer.
 */
(() => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('[aria-controls^="QuickView-"]');
    if (!btn) return;
    const card = btn.closest('.product-card__wrapper, .product-card');
    const link = card?.querySelector('.product-card__title a[href*="/products/"]');
    const modal = document.getElementById(btn.getAttribute('aria-controls'));
    if (!link || !modal) return;
    const url = new URL(link.getAttribute('href'), location.origin).pathname;
    if (modal.dataset.productUrl?.split('?')[0] !== url) modal.dataset.productUrl = url;
  }, true);
})();